// Shared greys for the Nova Studio shell. These aren't in the design system's token set yet, so
// they're centralised here rather than repeated as inline hexes across the catalogue, header, shell
// and version-history components. Replace with `theme.sys.*` tokens once equivalents exist.
export const NovaStudioColor = {
	// Hairline borders separating the catalogue panel, header and version rows.
	border: '#e6e8f0',
	// Secondary/label text (category names, tab hints, muted metadata).
	textMuted: '#6b7280',
	// Background of the per-category agent-count badge.
	badgeBackground: '#eef0f5',
	// Agent row label while the row is not selected.
	agentRowText: '#33334d',
	// Keyboard-focus ring for the hand-rolled buttons (collapsible bar, variable rows) whose
	// `all: unset` strips the default outline. A high-contrast blue so it reads as a focus cue.
	focusRing: '#0b63ce',
	// The dry-run surface is tinted so it reads as a different kind of thing from the authoring inputs
	// it sits under: those are yours to edit, this is the agent answering. Both values mirror the
	// design system's blue reference scale (blue.50 / blue.100) — the same scale its `border.active`
	// and `iconfill.primary` tokens are built from. They are spelled out here because the set has no
	// semantic "informative surface" background yet; swap them for tokens once it does. The Nova mark
	// brings its own colour, so no brand value is needed here.
	novaSurface: '#e5f4ff',
	novaSurfaceBorder: '#addbff',
} as const;
